import { doc, runTransaction } from 'firebase/firestore';
import { db } from './firebase';

import { assertResourceAvailable } from '../utils/resourceLifecycle';

// Every dependency is read before the caller writes. A deletion starting
// between this read and commit makes Firestore retry and reject the save.
export async function assertCategoriesAvailable(transaction, companyId, categoryIds) {
  for (const categoryId of new Set(categoryIds)) {
    const ref = doc(db, `users/${companyId}/tag_categories`, categoryId);
    assertResourceAvailable(await transaction.get(ref), `Attribute category ${categoryId}`);
  }
}

export async function saveCategoryValue(companyId, categoryId, valueId, value) {
  await runTransaction(db, async (transaction) => {
    await assertCategoriesAvailable(transaction, companyId, [categoryId]);
    transaction.set(doc(db, `users/${companyId}/tag_categories/${categoryId}/values`, valueId), value);
  });
}
